import React, { createContext, useState } from 'react';

export const DetailProductContext = createContext();

export const DetailProductProvider = ({ children }) => {
  const [product, setProduct] = useState([]);

  return (
    <DetailProductContext.Provider value={{ product, setProduct}}>
      {children}
    </DetailProductContext.Provider>
  );
};
